<script setup lang="ts">
import { ISidebarItem } from '@/interfaces/components/sidebar/sidebarItem'
import { useSidebarStore } from '@/store/sidebar'
import { useRoute } from 'vue-router'

const sidebarStore = useSidebarStore()
const route = useRoute()

const props = defineProps<{
  items: ISidebarItem[]
}>()

const isItemActive = (item: ISidebarItem) => {
  if (route.path === item.route || route.path.startsWith(`${item.route}/`)) {
    return true
  }

  return (item.activeMatchers || []).some((matcher) => route.path.startsWith(matcher))
}

const handleItemClick = () => {
  if (window.innerWidth < 1024) {
    sidebarStore.closeSidebar()
  }
}
</script>

<template>
  <ul class="mb-5.5 mt-4 flex flex-col gap-2.5 pl-6">
    <template v-for="(childItem, index) in props.items" :key="index">
      <li>
        <router-link
          :to="childItem.route"
          @click="handleItemClick"
          class="group relative flex items-center gap-2.5 px-4 font-medium text-bodydark2 duration-300 ease-in-out hover:text-white"
          :class="{
            '!text-white': isItemActive(childItem),
          }">
          {{ childItem.label }}
        </router-link>
      </li>
    </template>
  </ul>
</template>
